
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Box, Toolbar, Button, FormControl, IconButton, InputLabel, MenuItem, Radio, Select, Tab, Tabs } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { DataGridPremium, useGridApiRef } from "@mui/x-data-grid-premium";
import { useCallback, useMemo, useRef, useState } from "react";
import Swal from 'sweetalert2';
import strings from "../../Globalization/index";
import { dataStore } from "../../Store";
import consts from "../../consts";
import Connection from "../../services/Connection";
import util from "../../util";
import { useModelForm } from '../../contexts/ModelForm';

const { isFromTrackingSystem } = util;
const { regex } = consts;
const defaultCodeOptions = ['Barcode'];
const validationRFID = ['RFIDEquipmentID', 'RFIDTagNumber'];
const newRecord = 1;
const TabPanel = ({ children, value, currentValue, sx = {}, ...other }) => {
	return (
		<div role="tabpanel" hidden={value !== currentValue} {...other}>
			{value === currentValue && (
				<Box sx={sx}>
					{children}
				</Box>
			)}
		</div>
	);
};

const isEditableRegex = /STERIS Admin|STERIS Specialist/i

const getRoles = () => {
	const { auth = {} } = dataStore?.getState() || {};
	const { tags = {} } = auth;
	return tags?.RoleName || '';
}

const TabComponent = ({ childrens, value, setState, state }) => {
	const handleChange = (newValue) => {
		const index = childrens.indexOf(newValue?.currentTarget?.textContent);
		setState({ ...state, value: index });
	};
	return (
		<Tabs value={value} onChange={handleChange} sx={{ background: "#3c85d0" }}>
			{childrens.map((child, index) => {
				return (
					<Tab
						key={index}
						label={child}
						value={index}
						sx={
							value === index
								? { background: "#757575", color: "#fff !important" }
								: { background: "#3c85d0", color: "#fff" }
						}
					/>
				);
			})}
		</Tabs>
	);
};
const CustomeToolBar = ({ type, isAdd = true, handleAddRow, isDisabled }) => {
	const role = getRoles();
	return (
		<Toolbar sx={{ justifyContent: 'flex-start' }}>
			{consts.rolesAllowedToModify.includes(role?.toLowerCase()) && isAdd && <Button variant="contained" disabled={isDisabled} color="success" startIcon={<AddIcon />} onClick={() => (handleAddRow({ type }))}> {strings.Add}</Button>}
		</Toolbar>
	);
};


const RenderCodeHeader = ({ colDef }) => {
	const { headerName, field } = colDef;
	const { formik } = useModelForm();
	const key = formik.errors.hasOwnProperty("ItemCodes") ? 'ItemCodes' : 'UserCodes';
	return (
		<Box sx={{ p: 1, display: 'flex', flexDirection: 'column' }} key={field}>
			{strings[headerName] || headerName}
			{!validationRFID.includes(field) && formik.errors[key] && Object.keys(formik.errors).length > 0 && (
				<Box color={'error.main'}>
					<Box key={key}>{strings[formik.errors[key]] || formik.errors[key]}</Box>
				</Box>
			)}
		</Box>
	);
};

export default function CatAdminForm({
	activeRecord = { record: {} },
	formik,
	isItemSync,
}) {
	const recordkey = isItemSync ? 'ItemCodes' : 'UserCodes';
	const [state, setState] = useState({
		rowIndex: null,
		isRefresh: false,
		isRowRefresh: false,
		value: 0,
		rowsValue: [],
		isEdit: false,
		isMonogoId: false,
	})
	const recordKeyValue = Array.isArray(formik.values[recordkey]) ? [...formik.values[recordkey]] : [];
	const isDisabled = isFromTrackingSystem({ formik });
	const cellInEditRef = useRef(null)
	const parmetersOptions = isItemSync ? activeRecord.combos.ItemSyncParameters : activeRecord.combos.UserSyncParameters;
	const apiRef = useGridApiRef();
	const children = [strings.Codes, strings.Parameters];

	const prakey = isItemSync ? 'ItemSyncParameters' : 'UserSyncParameters';
	const spaceRegex = /^\s*$/;
	const role = getRoles();
	const { UseRFID, isISARFID, isRapidAERRFID } = activeRecord.record || {};
	const codeValueOptions = [...defaultCodeOptions];
	if (UseRFID) {
		if (isISARFID) codeValueOptions.push('RFID ISA');
		if (isRapidAERRFID) codeValueOptions.push('RFID RAER');
	}
	const codeValueSetter = (value, row) => {
		if (cellInEditRef.current) {
			cellInEditRef.current.value = value
		}
		return { ...row, Code: value }
	}
	/*
	   In checkValueExists function first Arguement is the Array of Object and Second Arguement is the key of Object on which we want to Compare with the Current Display Value. 
	*/
	function checkValueExists(parameterData, key, DisplayValue) {
		for (let i = 0; i < parameterData?.length; i++) {
			if (parameterData[i][key] === DisplayValue) {
				return true;
			}
		}
		return false;
	}
	const parametersRows =
		useMemo(
			() =>
				activeRecord?.record?.Parameters?.map((item, index) => ({
					...item,
					id: index + 1,
				})),
			[activeRecord.record.Parameters, state.isRowRefresh]
		);
	const CodesRows = useMemo(
		() =>
			recordKeyValue.map((item, index) => ({
				...item,
				id: index + 1,
			})),
		[recordKeyValue]
	);
	const onCreateOption = (LookupTypeId, addedValue) => {
		let action = 'save'
		let id = 0;
		let camelCasingValue = (addedValue.charAt(0).toLowerCase() + addedValue.slice(1)).replace(/\s+/g, '');
		const formData = new FormData();
		formData.append('action', action);
		formData.append('id', id);
		formData.append('LookupTypeId', LookupTypeId);
		formData.append('CustomStringValue', camelCasingValue);
		formData.append('DisplayValue', addedValue);
		try {
			fetch(Connection.Lookup, {
				method: 'POST',
				body: formData,
				credentials: 'include'
			})
		} catch (error) {
			console.error('Error creating record:', error);
		}
	}


	const handleRemove = useCallback((type, id) => {
		if (CodesRows?.length > 1 && (type === 'UserCode' || type === 'ItemCodes')) {
			activeRecord.record[recordkey] = CodesRows?.filter(data => data.id !== id);
			const removeBarcodes = formik.values.RemoveCodes.concat(CodesRows?.filter(data => data.id === id));
			formik.setFieldValue(recordkey, activeRecord.record[recordkey]);
			formik.setFieldValue('RemoveCodes', removeBarcodes)
		} else if (type === 'Parameters') {
			activeRecord.record.Parameters = parametersRows?.filter(data => data.id !== id);
			formik.setFieldValue('Parameters', activeRecord.record.Parameters);
		} else { Swal.fire({ title: strings.WarningTitle, text: strings.BarCodeRequired, icon: 'warning', confirmButtonText: strings.Ok, allowOutsideClick: false }); }
	}, [CodesRows]);

	const handleActive = useCallback((id, row) => {
		const newValue = CodesRows?.map((data, i) => {
			if (data.id === id) {
				data.IsActive = !row.IsActive;
			}
			if (i === cellInEditRef.current?.index) {
				data[cellInEditRef.current.field] = cellInEditRef.current.value
			}
			return data
		})
		formik.setFieldValue(recordkey, newValue)
	}, [CodesRows, formik]);

	const handleDefaultCheck = useCallback((id, row) => {
		const { CodeType } = row;
		const newValue = CodesRows.map((data, i) => {
			if (data.CodeType === CodeType) { // Check if the row has the same CodeType as the clicked row
				if (data.id === id) {
					data.DefaultValue = true;
					data.IsActive = true;
				} else {
					data.DefaultValue = false;
				}
			}
			if (i === cellInEditRef.current?.index) {
				data[cellInEditRef.current.field] = cellInEditRef.current.value
			}
			return data
		}
		)
		formik.setFieldValue(recordkey, newValue)
	}, [CodesRows, formik]);

	const CodesColumns = [
		{
			headerName: "CodeType",
			field: "CodeType",
			width: 150,
			editable: !isDisabled,
			type: 'singleSelect',
			valueOptions: codeValueOptions,
			valueSetter: (value, row) => {
				if (cellInEditRef.current) {
					cellInEditRef.current.value = value
				}
				const defaultRfidExist = CodesRows.some(data => (consts.rfidOptions.includes(data.CodeType) && data.DefaultValue === true)); // checking default RFID exits
				if (consts.rfidOptions.includes(value) && !defaultRfidExist) { // if default RFID not exist then add default RFID
					const lastIndex = apiRef.current.getRowsCount() - 1;
					const newCodesRows = [...CodesRows.slice(0, CodesRows.length - 1), { id: lastIndex, CodeType: value, IsActive: true, DefaultValue: true }];
					formik.setFieldValue(recordkey, newCodesRows);
				}
				return { ...row, CodeType: value };
			}
		},
		{
			headerName: "Code",
			field: "Code",
			width: 250,
			type: 'string',
			editable: !isDisabled,
			valueSetter: codeValueSetter,
			renderHeader: RenderCodeHeader,
			cellClassName: ({ row = {} }) => {
				const t = (row.CodeType || '').toString().trim().toLowerCase();
				return (['rfid isa', 'rfid raer'].includes(t) || row.IsDefaultBarcode) ? 'disabled-code-cell' : '';
			}
		},
		{
			headerName: "RFIDTagNumber",
			field: "RFIDTagNumber",
			width: 250,
			type: 'string',
			editable: !isDisabled,
			valueSetter: codeValueSetter,
			renderHeader: RenderCodeHeader,
			cellClassName: ({ row = {} }) => {
				const t = (row.CodeType || '').toString().trim().toLowerCase();
				return ['barcode'].includes(t) ? 'disabled-code-cell' : '';
			}
		},
		{
			headerName: "RFIDEquipmentID",
			field: "RFIDEquipmentID",
			width: 250,
			type: 'string',
			editable: !isDisabled,
			valueSetter: codeValueSetter,
			renderHeader: RenderCodeHeader,
			cellClassName: "disabled-code-cell"
		},
		{
			id: 3, field: "IsActive", headerName: 'Active', width: 100, renderCell: ({ id, row, ...other }) => {
				return (
					<Checkbox
						color="primary"
						disabled={row.IsDefaultBarcode || isDisabled}
						checked={row.IsActive || row.DefaultValue}
						onClick={() => handleActive(id, row)}
					>
					</Checkbox>
				);
			}
		},
		{
			headerName: 'Default', id: 4, field: "DefaultValue", width: 150, type: 'actions',
			renderCell: ({ id, row }) => {
				return (
					<Radio
						color="primary"
						checked={row.DefaultValue}
						onClick={() => handleDefaultCheck(id, row)}
						disabled={isDisabled}
					/>
				);
			}
		},
		{
			field: 'actions',
			type: 'actions',
			headerName: 'Remove',
			width: 100,
			renderCell: ({ id, row }) => {
				return (
					<IconButton
						color="error"
						onClick={() => handleRemove('UserCode', id)}
						disabled={row.IsDefaultBarcode || !role.match(isEditableRegex) || isDisabled}
					>
						<DeleteIcon />
					</IconButton>
				);
			}
		}
	];
	const parametersColumns = [
		{ headerName: "Key", field: "Key", width: 300, editable: (state.isEdit ? true : false) },
		{
			headerName: "Value", field: "Value", width: 120, editable: true, valueSetter: (value, row) => {
				if (cellInEditRef.current) {
					cellInEditRef.current.value = value
				}
				return row
			},
			renderCell: ({ field, row, id }) => {
				const { Key, Value } = row;
				const handleChange = (e) => {
					const nextParams = { ...row, [field]: e.target.value, id: row?._id || apiRef.current.getRowsCount() + 1 }
					apiRef.current.updateRows([nextParams]);
					activeRecord.record.Parameters[id - 1] = nextParams;
					formik.setFieldValue('Parameters', activeRecord.record.Parameters, true);
					setState({ ...state, isRowRefresh: !state.isRowRefresh, isEdit: true });
				}

				if (Key === 'UseAlcohol') {
					return (
						<FormControl fullWidth>
							<InputLabel id="available-label" style={{ display: 'none' }} >{Key}</InputLabel>
							<Select
								labelId="available-label"
								id="available-select"
								value={Value}
								onChange={handleChange}
								disabled={!role.match(isEditableRegex)}
							>
								<MenuItem value="true">Yes</MenuItem>
								<MenuItem value="false">No</MenuItem>
							</Select>
						</FormControl>
					);
				} else {
					return Value;
				}
			}

		}
	];
	const handleAddRow = useCallback(async ({ type }) => {
		let newRow;
		let newRecord;
		if (type === 'Codes') {
			newRecord = { CodeType: 'Barcode', Code: ``, Active: true, DefaultValue: false, isNew: true, IsDefaultBarcode: false }
			newRow = { id: apiRef.current.getRowsCount() + 1, ...newRecord };
			formik.setFieldValue(recordkey, [...CodesRows, newRow], true);
		}
		else {
			newRecord = { Key: '', Value: '', ReadOnly: false }
			newRow = { id: apiRef.current.getRowsCount() + 1, ...newRecord };
			formik.setFieldValue('Parameters', [...formik.values.Parameters, newRecord], true);
		}
		apiRef.current.updateRows([newRow]);
		setState({ ...state, isRowRefresh: !state.isRowRefresh })
	}, [CodesRows, formik]);



	const onCellEdit = useCallback((params) => {
		try {
			let { field, row, value, index } = params;
			const isValueExisted = checkValueExists(parmetersOptions, 'DisplayValue', value);
			let nextParams;
			if ((field === "Key" || field === 'Value') && !row.ReadOnly) {
				//Showing the Sweet Alert when User Try to Create New Option in Dropdown Value but that Value is Already Existed.
				if (isValueExisted === true) {
					Swal.fire({
						title: strings.WarningTitle,
						text: strings.AlertForExistedParameterValue,
						icon: 'warning',
						confirmButtonText: strings.Ok,
						allowOutsideClick: false
					});
				}
				//Adding the condition Where We Check is Value has only Space in string or Value is equal to Undefined.
				else if (value !== undefined && spaceRegex.test(value) === false) {
					nextParams = { ...row, [field]: value, id: row?._id || apiRef.current.getRowsCount() + 1 }
					apiRef.current.updateRows([nextParams]);

					activeRecord.record.Parameters[index] = nextParams;
					formik.setFieldValue('Parameters', activeRecord.record.Parameters, true);
					if (field === "Key") {
						onCreateOption(consts.LookupType[prakey], value);
						activeRecord.combos[prakey].push({ Lookup: value, DisplayValue: value });
					}
				}
				// This Condition Runs when User Try to add new Dropdown value but they did'nt add anything in it.
				else {
					nextParams = { ...row, [field]: value }
					apiRef.current.updateRows([nextParams]);
				}
			}
			if (["Code", "Active", "CodeType", "RFIDEquipmentID", "RFIDTagNumber"].includes(field)) {
				if (!row) {
					row = recordKeyValue[index];
				}
				nextParams = { ...row, [field]: value, id: row?._id || apiRef.current.getRowsCount() + 1 };
				apiRef.current.updateRows([nextParams]);
				const newRecordKeyValue = [...recordKeyValue];
				newRecordKeyValue[index] = nextParams;
				formik.setFieldValue(recordkey, newRecordKeyValue, true);
			}
			setState({ ...state, isRowRefresh: !state.isRowRefresh, isEdit: true })
		}
		catch (err) {
			console.error(err);
		}
	}, [recordKeyValue, recordkey]);

	const processRowUpdate = useCallback((newRow) => {
		if (cellInEditRef.current?.field) {
			cellInEditRef.current = { ...cellInEditRef.current, row: { ...cellInEditRef.current?.row, [cellInEditRef.current.field]: cellInEditRef.current.value } }
			onCellEdit(cellInEditRef.current);
		}
		return newRow;
	}, [onCellEdit]);

	const onCellEditStop = useCallback((id, row) => {
		const newValue = CodesRows?.map((data, i) => {
			if (i === cellInEditRef.current?.index) {
				data[cellInEditRef.current.field] = cellInEditRef.current.value
			}
			if (data.Code) {
				data.Code = data.Code.replace(regex.curlyBraceReg, '');
			}
			return data
		})
		formik.setFieldValue(recordkey, newValue)
		cellInEditRef.current = null;
	}, [CodesRows, formik]);

	const onCellEditStart = ({ colDef, id, row }) => {
		let index = id - 1; // getting index of record
		index = index === -1 ? 0 : index;
		cellInEditRef.current = { field: colDef.field, index, row }
	}

	const codesColumnDetails = useMemo(() =>
		CodesColumns.map(codeData => ({ ...codeData, headerName: strings[codeData.headerName] || codeData.headerName }))
		, [CodesColumns]);

	const parameterDataDetails = useMemo(() =>
		parametersColumns.map(parameterData => ({ ...parameterData, headerName: strings[parameterData.headerName] || parameterData.headerName }))
		, [parametersColumns]);

	return (
		<Box>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<TabComponent childrens={children} setState={setState} value={state.value} state={state} />
			</Box>
			<TabPanel value={0} currentValue={state.value} sx={{ height: 400 }}>
				<DataGridPremium
					rows={CodesRows}
					columns={codesColumnDetails}
					sx={{
						border: 'none',
						'& .disabled-code-cell': {
							bgcolor: '#f5f5f5',
							color: '#9e9e9e',
							pointerEvents: 'none',
							boxSizing: 'border-box',
							borderLeft: '1px solid #e0e0e0',
							borderRight: '1px solid #e0e0e0'
						}
					}}
					slots={{
						toolbar: CustomeToolBar
					}}
					slotProps={{
						toolbar: {
							type: "Codes",
							handleAddRow,
							isDisabled
						}
					}}
					apiRef={apiRef}
					disableMultipleRowSelection
					disableColumnMenu
					isCellEditable={({ id, row, field }) => {
						if (row.IsDefaultBarcode) return false;
						if (consts.regex.mongoId.test(row._id) && consts.rfidOptions.includes(row.CodeType) && ['CodeType'].includes(field)) {
							return false;
						}
						if (validationRFID.includes(field)) {
							return !defaultCodeOptions.includes(row.CodeType);
						}
						return true;
					}}
					onCellEditStart={onCellEditStart}
					processRowUpdate={processRowUpdate}
					onCellEditStop={onCellEditStop}
					editMode={isDisabled ? undefined : "cell"}
					showToolbar
				/>

			</TabPanel>
			<TabPanel value={1} currentValue={state.value} sx={{ height: 400, width: "95%" }}>
				<DataGridPremium
					rows={parametersRows}
					columns={parameterDataDetails}
					sx={{ border: "none", textDecoration: "" }}
					showToolbar
					slots={{
						toolbar: CustomeToolBar,

					}}
					slotProps={{
						toolbar: {
							type: "Parameters",
							isAdd: false,
							handleAddRow
						},
					}}
					onSelectionModelChange={(index) => setState({ ...state, rowIndex: index })}
					apiRef={apiRef}
					disableMultipleRowSelection
					disableColumnMenu
					isCellEditable={(params) => {
						// Making Value column editable based on ReadOnly                                                                                                                                             
						if (params.value !== 'UseAlcohol') {
							return false
						} else if (params.field === 'Value') {
							return !params.row.ReadOnly;
						}
						return false;
					}}
					onCellEditStart={onCellEditStart}
					processRowUpdate={processRowUpdate}
					onCellEditStop={onCellEditStop}
					editMode={isDisabled ? undefined : "cell"}
				/>
			</TabPanel>
		</Box>
	);
}